const aws = {
  aws_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_aNPLtlYL8',
  aws_user_pools_web_client_id: 'f56l08lsj99r2cj2d1j1lfco7',
}

export default aws
